<template>
    <div class="my-lg-3">
        <ul class="nav nav-tabs mt-3 mt-lg-0" id="bizPageInfo" style="cursor: pointer;">
            <li class="nav-item">
                <a @click="bind('products')" id="productControl" class="nav-link active px-sm-3 px-1" data-toggle="tab"
                   href="#products" data-target="#products"
                   role="tab" aria-controls="products" aria-selected="true">
                    Products
                </a>
            </li>
            <li class="nav-item">
                <a @click="bind('about')" id="aboutControl" class="nav-link px-sm-3 px-1" data-toggle="tab"
                   data-target="#about" href="#about"
                   role="tab" aria-controls="about" aria-selected="true">
                    About
                </a>
            </li>
            <li class="nav-item">
                <a @click="loadReviewTab = true; bind('reviews')"
                   id="reviewControl" class="nav-link px-sm-3 px-1 text-black" data-toggle="tab" data-target="#reviews"
                   href="#reviews"
                   role="tab" aria-controls="reviews" aria-selected="true">
                    Reviews
                </a>
            </li>
            <li class="nav-item">
                <a @click="loadDealTab = true; bind('deals')"
                   id="dealsControl" class="nav-link px-sm-3 px-1" data-toggle="tab" data-target="#deals" href="#deals"
                   role="tab" aria-controls="deals" aria-selected="true">
                    Deals
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <div class="tab-pane fade show active" id="products" role="tabpanel">
                <product-tab :business="business"
                             :products="products"
                             :product-filters="productFilters">
                </product-tab>
            </div>

            <!-- This tab is always included with initial load
                 need to re-work the Google Maps (and operating hours) implementation to load it dynamically -->
            <div class="tab-pane fade" id="about" role="tabpanel">
                <slot name="aboutTab"></slot>
            </div>

            <div class="tab-pane fade" id="reviews" role="tabpanel" >
                <review-tab v-if="loadReviewTab"
                            :user="user"
                            :reviews="reviews"
                            :business-name="business.bizName"
                            :hasReview="hasReview">
                </review-tab>
            </div>

            <div class="tab-pane fade" id="deals" role="tabpanel">
                <deal-tab v-if="loadDealTab" :business="business"></deal-tab>
            </div>
        </div>
    </div>
</template>

<script>
import DealTab from "./DealTab";
import ProductTab from "./ProductTab";
import ReviewTab from "./ReviewTab";

export default {
    name: "BusinessListingTabs",
    components: {
        DealTab,
        ProductTab,
        ReviewTab
    },
    props: {
        user: Object,
        business: Object,
        reviews: Array,
        products: Object,
        productFilters: Object
    },
    data() {
        return {
            loadReviewTab: false,
            loadDealTab: false,
            hasReview:this.$attrs['hasreview'],
            activeTab: "products"
        }
    },
    mounted() {
        //add a click event listener to the "View reviews" button (found in reviewControls.blade.php)
        let btnViewReviews = this.$parent.$refs.btnViewReviews;
        btnViewReviews.addEventListener("click", () => {
            this.loadReviewTab = true;

        });

        const url = window.location.href;
        if (url.indexOf("#") > 0) {
            var activeTab = url.substring(url.indexOf("#") + 1);


            switch (activeTab) {
                case "reviews":
                    this.loadReviewTab = true;
                    break;
                case "deals":
                    this.loadDealTab = true;
                    break;
            }


            $('.nav-tabs a[href="#' + activeTab + '"]').tab('show');


            //  $('.nav[role="tablist"] a[href="#'+activeTab+'"]').tab('show');
        }
        $('a[role="tab"]').on("click", function () {
            var newUrl;
            const hash = $(this).attr("href");
            newUrl = url.split("#")[0] + hash;
            history.replaceState(null, null, newUrl);
        });
    },
    methods:
        {
            bind: function (message) {
                this.activeTab = message
            },
            scroll: function (id) {
                document.getElementById(id).scrollIntoView({
                    behavior: "smooth"
                });
            }
        },
    updated() {
        var url = window.location.href;
        if (url.indexOf("#") > 0) {
            this.scroll("bizPageInfo")

        }
    }
}
</script>

<style scoped>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #00937F;
}

a {
    color: black;
    background-color: transparent;
    text-decoration: none;
}
</style>
